import { Activity, Video } from 'react-feather'
import { t } from '@lingui/core/macro'

import { MeetingLinkOrder } from '@/core/graphql/types'
import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Link } from '@/lib/next-shim'
import DoctorIcon from '@/assets/svg/Doctor'

export function DoctorCard({ order }: { order: MeetingLinkOrder }) {
  const consultationId = order.consultation?._id

  return (
    <Card className="bg-white flex flex-col items-center rounded-2xl border-gray-200 p-6 text-center shadow-sm">
      <div className="mb-4 h-24 w-24 overflow-hidden rounded-full border-4 border-gray-100 bg-gray-100">
        {order.acceptedBy ? (
          <DoctorIcon className="h-full w-full object-cover" isFemale={order.acceptedBy.userInfo.gender === 'F'} />
        ) : (
          <div className="flex h-full w-full items-center justify-center">
            <Activity className="h-10 w-10 text-primary" />
          </div>
        )}
      </div>
      {order.acceptedBy ? (
        <>
          <h3 className="text-lg font-bold text-gray-900">
            Dr. {order.acceptedBy.userInfo.surname} {order.acceptedBy.userInfo.name}
          </h3>
          <p className="mb-4 text-sm font-medium capitalize text-primary">{order.acceptedBy.speciality || order.speciality}</p>
          {consultationId ? (
            <Link
              href={`/account/consultations/${consultationId}`}
              className="inline-flex w-full items-center justify-center rounded-full bg-primary px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
            >
              <Video size={16} className="mr-2" />
              {t`View consultation`}
            </Link>
          ) : (
            <Button className="w-full rounded-full" disabled variant="outline">
              {t`Contact doctor`}
            </Button>
          )}
        </>
      ) : (
        <>
          <h3 className="text-lg font-bold text-gray-900">{t`Awaiting assignment`}</h3>
          <p className="mb-4 text-sm text-gray-500">{t`A doctor will accept your request soon.`}</p>
        </>
      )}
    </Card>
  )
}
